export default "__VITE_ASSET__BIN9GX9V__"